const  router = [
	{
		path: "/member/layout",
		component: () => import('../../../pages/member/Layout.vue'),
		meta: {title: '会员管理'},
		name: 'member_layout',
		children:[
			{
				path: "/member",
				component: () => import('../../../pages/member/Index.vue'),
				meta: {title: '会员管理', type:'m', permission: 'memberIndex'},
				// name: 'member_index',
				name: 'memberIndex',
			},
			{
				path: "/member/rank",
				component: () => import('../../../pages/member/Rank.vue'),
				meta: {title: '会员等级', type:'c', permission: 'member_rank'},
				name: 'member_rank',
			},
			{
				path: "/member/integral",
				component: () => import('../../../pages/member/Integral.vue'),
				meta: {title: '会员积分', type:'c', permission: 'member_integral'},
				name: 'member_integral',
			},
			{
				path: "/member/money",
				component: () => import('../../../pages/member/Money.vue'),
				meta: {title: '会员余额', type:'c', permission: 'member_money'},
				name: 'member_money',
			},
			{
				path: "/member/detail",
				component: () => import('../../../pages/member/Detail.vue'),
				meta: {title: '会员详情', type:'c', permission: 'member_index_detail'},
				name: 'member_index_detail',
			},
			{
				path: "/member/discount",
				component: () => import('../../../pages/member/Discount.vue'),
				meta: {title: '会员优惠', type:'c', permission: 'member_discount'},
				name: 'member_discount',
			},
			{
				path: "/member/report",
				component: () => import('../../../pages/member/Report.vue'),
				meta: {title: '会员报告', type:'c', permission: 'member_report'},
				name: 'member_report',
			},
			{
				path: "/member/supplement",
				component: () => import('../../../pages/member/Supplement.vue'),
				meta: {title: '线下补单', type:'c', permission: 'member_supplement'},
				name: 'member_supplement',
			},
			{
				path: "/member/buy",
				component: () => import('../../../pages/member/Buy.vue'),
				meta: {title: '买单记录', type:'c', permission: 'member_buy'},
				name: 'member_buy',
			},
			{
				path: "/member/chongzhi",
				component: () => import('../../../pages/member/Chongzhi.vue'),
				meta: {title: '充值记录', type:'c', permission: 'member_chongzhi'},
				name: 'member_chongzhi',
			},
		]
	}
];

export default router